module.exports = __webpack_public_path__ + "img/V.1 020921 Journey Background Wave Comp0.dbdb166f.png";